const MIN_WORDS = 60;
const MIN_SENTENCES = 4;
const SENTENCES_PER_PARAGRAPH = 3;

const URL_MASK_OPEN = '';
const URL_MASK_CLOSE = '';
const ABBREV_DOT = '';

const ABBREVIATIONS = /\b(?:e\.g|i\.e|U\.S|U\.K|etc|Dr|Mr|Mrs|Ms|St|vs|Prof|Jr|Sr)\./gi;
const MARKDOWN_LINK = /\[([^\]]+)\]\(([^)]+)\)/g;

const splitSentences = (text: string): string[] => {
  const urls: string[] = [];
  let masked = text.replace(MARKDOWN_LINK, (_, label: string, url: string) => {
    urls.push(url);
    return `[${label}](${URL_MASK_OPEN}${urls.length - 1}${URL_MASK_CLOSE})`;
  });
  masked = masked.replace(ABBREVIATIONS, (m) => m.replace(/\./g, ABBREV_DOT));

  const parts = masked.split(/(?<=[.!?])\s+/);

  /* eslint-disable i18next/no-literal-string -- regular expression flags */
  const restoreUrls = new RegExp(`${URL_MASK_OPEN}(\\d+)${URL_MASK_CLOSE}`, 'g');
  const restoreDots = new RegExp(ABBREV_DOT, 'g');
  /* eslint-enable i18next/no-literal-string */
  return parts
    .map((s) =>
      s
        .replace(restoreDots, '.')
        .replace(restoreUrls, (_, i: string) => urls[Number(i)])
        .trim(),
    )
    .filter(Boolean);
};

export const paragraphize = (text: string): string => {
  // Skip if author/LLM already structured the text (any newline counts as intentional).
  if (!text || /\n/.test(text)) return text;
  if (text.trim().split(/\s+/).length < MIN_WORDS) return text;

  const sentences = splitSentences(text);
  if (sentences.length < MIN_SENTENCES) return text;

  const chunks: string[] = [];
  for (let i = 0; i < sentences.length; i += SENTENCES_PER_PARAGRAPH) {
    chunks.push(sentences.slice(i, i + SENTENCES_PER_PARAGRAPH).join(' '));
  }
  return chunks.join('\n\n');
};
